import React from 'react';
import ModalManager from "../../../components/common/modal/ModalManager";
import NotificationManager from "../../../utils/notificationManager";
import axios from "axios";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import TextInput from "../../../components/common/inputs/textInput";
import DeviceLogChart from "../../../components/devices/deviceLogChart";
import OutletCard from "../../../components/devices/OutletCard";

// function timeout(ms) {
//   return new Promise((resolve) => setTimeout(resolve, ms));
// }
export default class DevicePageOutlets extends React.Component {
  state = {
    batchOperationLoading: false,
    outletDelay: 3,
    loadingOutlets: [],
    pendingOutletUuids: [],
    numFinished: 0,
    searchBar: "",
    currentFilter: "",
    chartzViewType: "outletSwitchingView", // outletSwitchingView
    groups: [],
    selectedGroupId: "",
    groupsLoading: false,
    selectedOutletIdForChart: "",
    dark: document.body.classList.contains("dark-mode"),

  };
  async componentDidMount() {
    this.fetchGroups();
    this.darkObserver = new MutationObserver(() => {
      const isDark = document.body.classList.contains("dark-mode");
      this.setState((prev) => (prev.dark === isDark ? null : { dark: isDark }));
    });
    this.darkObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  }
  componentWillUnmount() {
    this.darkObserver && this.darkObserver.disconnect();
  }
  fetchGroups = () => {
    const serial = this.props.device?.enclosureSerialNumber;
    if (!serial) return;
    this.setState({ groupsLoading: true });
    axios
      .get(`/v1/devices/${serial}/outlet-groups`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((res) => {
        this.setState({ groups: res.data.data || [], groupsLoading: false });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ groupsLoading: false });
      });
  };
  getOutletGroupModalOptions = () => ({
    preventOutsideClose: true,
    modalStyle: {
      minWidth: "520px",
      width: "620px",
      maxWidth: "90vw",
      maxHeight: "85vh",
    },
    contentStyle: {
      maxHeight: "70vh",
      overflowY: "auto",
    },
  });
  onGroupSelect = (e) => {
    if (e.target.value === "create") {
      this.openCreateGroup();
      return;
    }
    this.setState({ selectedGroupId: e.target.value });
  };
  openCreateGroup = () => {
    const serial = this.props.device?.enclosureSerialNumber;
    if (!serial) return;
    ModalManager.confirm(
      "",
      "Create Outlet Group",
      "",
      (submitted, close) => {
        if (submitted && close) {
          close();
        }
      },
      ({ close }) => (
        <OutletGroupForm
          outlets={this.props.outlets}
          onSubmit={(data, done) => {
            axios
              .post(`/v1/devices/${serial}/outlet-groups`, data, {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token"),
                },
              })
              .then(() => {
                NotificationManager.success("Group created");
                this.fetchGroups();
                done && done();
                close();
              })
              .catch((err) => {
                console.error(err);
                NotificationManager.alert("Failed to create group");
                done && done();
                close();
              });
          }}
          close={close}
        />
      ),
      true,
      true,
      this.getOutletGroupModalOptions()
    );
  };
  openEditGroup = () => {
    const serial = this.props.device?.enclosureSerialNumber;
    const group = this.state.groups.find(
      (g) => g.id === this.state.selectedGroupId
    );
    if (!serial || !group) return;
      ModalManager.confirm(
        "",
        "Edit Outlet Group",
        "",
        (submitted, close) => {
          if (submitted && close) {
            close();
          }
        },
        ({ close }) => (
        <OutletGroupForm
          outlets={this.props.outlets}
          group={group}
          onSubmit={(data, done) => {
            axios
              .put(
                `/v1/devices/${serial}/outlet-groups/${group.id}`,
                data,
                {
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("token"),
                  },
                }
              )
              .then(() => {
                NotificationManager.success("Group updated");
                this.fetchGroups();
                done && done();
                close();
              })
              .catch((err) => {
                console.error(err);
                NotificationManager.alert("Failed to update group");
                done && done();
                close();
              });
          }}
          close={close}
        />
      ),
      true,
      true,
      this.getOutletGroupModalOptions()
    );
  };
  deleteGroup = () => {
    const serial = this.props.device?.enclosureSerialNumber;
    const { selectedGroupId } = this.state;
    if (!serial || !selectedGroupId) return;
    ModalManager.confirm(
      "This will permanently delete this outlet group.",
      "Are you sure you want to delete this group?",
      "Delete",
      (submitted, close) => {
        if (submitted) {
          this.setState({ groupsLoading: true });
          axios
            .delete(`/v1/devices/${serial}/outlet-groups/${selectedGroupId}`, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            .then(() => {
              NotificationManager.success("Group deleted");
              this.setState({ selectedGroupId: "" });
              this.fetchGroups();
            })
            .catch((err) => {
              console.error(err);
              NotificationManager.alert("Failed to delete group");
              this.setState({ groupsLoading: false });
            });
        }
        close && close();
      }
    );
  };
  editOutletName = (outlet) => {
    ModalManager.confirm(
      "",
      `Outlet ${outlet.outlet_id}`,
      "",
      (submitted, close) => {
        if (submitted) {
          close();
        }
      },
      ({ close }) => (
        <EditOutletForm
          updateOutlet={this.props.updateOutlet}
          outlet={outlet}
          close={close}
        />
      ),
      true,
      true
    );
  };
  updateOutlet = (outletId, status, cb = () => {}, idField, noNotification) => {
    this.setState({
      loadingOutlets: [...this.state.loadingOutlets, outletId],
    });
    this.props.modifyResource(
      "outlets",
      outletId,
      status,
      (err, res) => {
        this.setState({
          loadingOutlets: this.state.loadingOutlets.filter(
            (o) => o !== outletId
          ),
        });
        cb(err, res);
        if (!err && res) {
          // console.log("hurray");
          try {
            if (status.state === "REBOOT") {
              const foundOutlet = this.props.outlets.find(
                (o) => o.outlet_id == outletId
              );
              const rebootTime = foundOutlet?.rebootTime;
              // make a fetch call to re-get the outlet or device one second after the reboot time, if no reboot time default to 5 seconds
              const fetchTime = rebootTime ? rebootTime + 1 : 5; // seconcs
              setTimeout(() => {
                // this.props.fetchResource("outlets");
                // this.props.fetchResource("devices");
                if (foundOutlet) {
                  this.props.refreshOutlets?.({
                    serial: foundOutlet.enclosureSerialNumber,
                    force: true,
                  });
                  this.props.refreshDevice?.();
                } else {
                  console.error(
                    "Could not update outlet information, missing serial number"
                  );
                }
              }, fetchTime * 1000); // setTimeout accepts ms
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          // console.log("wah");
        }
      },
      idField,
      noNotification
    );
  };
  cancelBatchOperation = () => {
    this.setState({
      numFinished: this.state.selectedOutlets.length,
      batchOperationLoading: false,
      // pendingOutletUuids: [],
      // loadingOutlets: [],
    });
  };
  
  render() {

    const { outlets, device, loading, updateOutlet } = this.props;

    const serial = device?.enclosureSerialNumber;
    const { groups, selectedGroupId, dark } = this.state;
    const filteredOutlets = selectedGroupId
      ? outlets.filter((o) => {
          const g = groups.find((gr) => gr.id === selectedGroupId);
          return g && g.outlets.some((go) => go.id === o.outlet_id);
        })
      : outlets;
    const columnWidths = [
      1, //0 checkbox
      1, //1 outlet#
      6, //2 outlet name
      4, //3 custom field 1
      4, //4 custom field 2
      5, //5 PDU
      2, //6 outlet state
      4, //7 outlet current
      3, //8 outlet power
      3, //9 outlet voltage
      8, //10 operation
      2, //11 updated
      1, //12 refresh
    ];
    const columnMap = {
      outletNumber: 1,
      outletName: 2,
      customField1: 3,
      customField2: 4,
      pdu: 5,
      state: 6,
      currentRms: 7,
      power: 8,
      voltage: 9,
      operation: 10,
    };
    const totalCurrentRms = filteredOutlets.reduce(
      (sum, item) => sum + (item.currentRms || 0),
      0
    );
    const averageCurrentRms =
      totalCurrentRms /
      filteredOutlets.filter(
        (o) => o.connectionState === "Connected"
      ).length;
    const highestCurrentRms =
      filteredOutlets.length > 0
        ? Math.max(
            ...filteredOutlets.map((o) => o.currentRms || 0)
          )
        : 0;
    const numUnused = filteredOutlets.filter(
      (o) => o.currentRms === 0
    ).length;
    const allOutletsAreSwitchedOnly =
      filteredOutlets.filter((o) => o.currentRms === undefined)
        .length === filteredOutlets.length;
    const noOutletsWithPowerMeasurements =
      filteredOutlets.filter((o) => o.currentRms === undefined)
        .length === filteredOutlets.length;
    const role = this.props.user.role;
    // const outletEditAllowed = !role || role.editAllOutletsAllowed
    const outletsSwitchesAllowed = (() => {
      if (!role) {
        return true;
      } else {
        if (role.switchAllOutletsAllowed) {
          return true;
        } else {
          return false;
        }
      }
    })();

    const measurementOutlets = device?.outletPwrMeasurementsSupported
      ? filteredOutlets
          .filter((o) => o?.outlet_id !== undefined && o?.outlet_id !== null)
          .sort((a, b) => {
            const left = a.pduLabeledOutletNum ?? a.outlet_id ?? 0;
            const right = b.pduLabeledOutletNum ?? b.outlet_id ?? 0;
            return left - right;
          })
      : [];

    let selectedOutletOption = measurementOutlets.find(
      (o) => String(o.outlet_id) === String(this.state.selectedOutletIdForChart)
    );
    if (!selectedOutletOption) {
      selectedOutletOption = measurementOutlets[0];
    }
    const selectedOutletIdForChart = selectedOutletOption?.outlet_id;

    const outletSelectionControls = measurementOutlets.length > 1 ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          // flexWrap: "wrap",
        }}
      >
        <span style={{ fontSize: "0.85rem", color: "#4b5563" }}>Outlet</span>
        <select
          value={selectedOutletOption ? String(selectedOutletOption.outlet_id) : ""}
          onChange={(e) => this.setState({ selectedOutletIdForChart: e.target.value })}
          style={{
            margin: 0,
            minWidth: "160px",
            padding: "0.35rem 0.5rem",
            borderRadius: "4px",
            border: "1px solid #d7dde2",
            backgroundColor: "#fff",
          }}
        >
          {measurementOutlets.map((o) => {
            const baseLabel = `Outlet ${o.pduLabeledOutletNum || o.outlet_id}`;
            const displayName =
              o.outletName && o.outletName !== `Outlet ${o.pduLabeledOutletNum}`
                ? `${baseLabel} – ${o.outletName}`
                : baseLabel;
            return (
              <option key={o.outlet_id} value={o.outlet_id}>
                {displayName}
              </option>
            );
          })}
        </select>
      </div>
    ) : null;

    const outletChartSubtitle = selectedOutletOption
      ? (() => {
          const base = `Outlet ${
            selectedOutletOption.pduLabeledOutletNum || selectedOutletOption.outlet_id
          }`;
          if (
            selectedOutletOption.outletName &&
            selectedOutletOption.outletName !== `Outlet ${selectedOutletOption.pduLabeledOutletNum}`
          ) {
            return `${base} – ${selectedOutletOption.outletName}`;
          }
          return base;
        })()
      : "";

    const canShowOutletLogChart = Boolean(
      device?.outletPwrMeasurementsSupported &&
      serial &&
      measurementOutlets.length > 0 &&
      selectedOutletIdForChart
    );
    return (
      <div>
        {!this.props.hideChartz && !allOutletsAreSwitchedOnly && (
          <div className="grid-x grid-padding-x">
            <div
              className="cell"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <select
                onChange={(e) => {
                  this.setState({ chartzViewType: e.target.value });
                }}
                style={{
                  margin: "0px",
                  width: "fit-content",
                  border: "none",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                }}
                value={this.state.chartzViewType}
              >
                <option value="outletCurrentView">
                  Outlet Measurement Stats
                </option>
                <option value="outletSwitchingView">
                  Outlet Switching Info
                </option>
              </select>
            </div>
          </div>
        )}
        {!this.props.hideChartz && (
          <Chartz
            loading={loading}
            sections={
              // all outlets read current RMS show following
              this.state.chartzViewType === "outletCurrentView"
                ? [
                    {
                      title: "Total Current RMS",
                      value: `${(totalCurrentRms || 0).toFixed(2)} A`,
                      description:
                        "All outlets with measurement capabilities summed",
                    },
                    {
                      title: "Average Current RMS",
                      value: `${(averageCurrentRms || 0).toFixed(2)} A`,
                      description:
                        "Average of all outlets with measurement capabilitties",
                    },
                    {
                      title: "Highest Current Outlet",
                      value: `${(highestCurrentRms || 0).toFixed(2)} A`,
                      description: "Individual highest outlet current",
                    },
                    {
                      title: "Unused Outlets",
                      value: `${numUnused} Outlets`,
                      description:
                        "Number of outlets with current RMS draw at 0 Amps",
                      // value: `${numOnOutlets} ON, ${numOffOutlets} OFF`,
                    },
                  ]
                : this.state.chartzViewType === "outletSwitchingView"
                ? [
                    {
                      title: "Number of Switchable Outlets",
                      value: `${
                        filteredOutlets.filter((o) => o.state)
                          .length
                      } Outlets`,
                      description:
                        "Number of outlets capable of switching outlets that are online and accessible",
                      // }, {
                      //   title: "Number Outlets Switched ON",
                      //   value: `${this.props.resources.devices.filter(d => (d.connectionState === "Connected") && d.outletSwitchingSupported).length}`,
                      //   description: "Number of PDUs online with switchable outlets"
                    },
                    {
                      title: "Number of Outlets Switched Off",
                      value: `${
                        filteredOutlets.filter(
                          (o) => o.state === "OFF"
                        ).length
                      }`,
                      description: `${
                        filteredOutlets.filter(
                          (o) => o.state === "OFF"
                        ).length
                      } out of a total of ${
                        filteredOutlets.filter(
                          (o) => o.connectionState === "Connected"
                        ).length
                      } outlets switched OFF`,
                    },
                    {
                      title: "unique_id",
                      component: () => {
                        return (
                          <div className="cell large-6 medium-12">
                            <div
                              style={{
                                flex: 1,
                                borderRadius: "3px",
                                display: "flex",
                                alignItems: "flex-start",
                                paddingLeft: "20px",
                                justifyContent: "flex-start",
                                height: "100%",
                                boxShadow: "2px 2px 5px rgba(0,0,0,0.14)",
                              }}
                              className="app-item"
                            >
                              <div style={{ width: "100%" }}>
                                <div
                                  style={{
                                    paddingBottom: "10px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                    <Link
                      to={`/activity/history?action=outlet_switched,outlet_edited${
                      this.props.device
                        ? `&enclosureSN=${this.props.device.enclosureSerialNumber}`
                        : ""
                    }`}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: dark ? "#e5e7eb" : "#333",
                          cursor: "pointer",
                          gap: 4,
                        }}
                      >
                        Outlet Activity Log
                        <i className="material-icons" style={{ color: dark ? "#e5e7eb" : "#333" }}>
                          chevron_right
                        </i>
                      </span>
                    </Link>
                                  {this.props.activityLoading ? (
                                    <Loading black />
                                  ) : (
                                    <span
                                      style={{
                                        color: dark ? "#cbd5e1" : "rgb(108,111,114)",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        this.props.grabActivityLog()
                                      }}
                                    >
                                      <i
                                        className="material-icons"
                                        style={{ fontWeight: "400" }}
                                      >
                                        sync
                                      </i>
                                    </span>
                                  )}
                                </div>
                                {this.props.activityLoading &&
                                  !this.props.activityLoaded && (
                                    <Loading black />
                                  )}
                                {(() => {
                                  const entries = this.props.activityLog
                                    .filter((a) => {
                                      if (a.action === "outlet_switched") {
                                        if (
                                          filteredOutlets.find(
                                            (o) => o.outlet_id === a.resourceId
                                          )
                                        ) {
                                          return true;
                                        } else {
                                          return false;
                                        }
                                      } else {
                                        return false;
                                      }
                                    })
                                    .slice(0, 5);
                                  if (entries.length === 0) {
                                    return (
                                      <div
                                        style={{
                                          color: dark ? "#cbd5e1" : "#666",
                                          fontSize: "87%",
                                          paddingBottom: "3px",
                                        }}
                                      >
                                        No activity found
                                      </div>
                                    );
                                  }
                                  return entries.map((a) => {
                                    return (
                                      <div
                                        key={a.createdAt}
                                        style={{
                                          color: dark ? "#cbd5e1" : "#666",
                                          fontSize: "87%",
                                          display: "flex",
                                          // borderBottom: "solid #eee 1px",
                                          paddingBottom: "3px",
                                          marginBottom: "3px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            // border: "solid red 1px",
                                            whiteSpace: "pre",
                                          }}
                                        >
                                          {format(
                                            new Date(a.createdAt),
                                            "MMM d, HH:mm"
                                          )}
                                          :{" "}
                                        </span>
                                        <span
                                          style={{
                                            // border: "solid blue 1px"
                                          }}
                                        >
                                          {a.details}
                                        </span>
                                      </div>
                                    );
                                  });
                                })()}
                              </div>
                            </div>
                          </div>
                        );
                      },
                    },
                  ]
                : []
            }
          />
        )}
        
        <div
          style={{
            borderBottom: "solid 1px #dedede",
            margin: "20px 0px 15px 30px",
          }}
        />

        <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
          <select
            value={this.state.selectedGroupId}
            onChange={this.onGroupSelect}
            style={{ marginRight: "10px" }}
            disabled={this.state.groupsLoading}
          >
            <option value="">Select an outlet action group</option>
            {this.state.groups.map((g) => (
              <option key={g.id} value={g.id}>
                {g.groupName}
              </option>
            ))}
            <option value="create">+ Create New Group</option>
          </select>
          {this.state.groupsLoading && <Loading black />}

        </div>
        <div
          
        >
          {this.state.selectedGroupId && !this.state.groupsLoading && (
            <>
              <button
                className="button"
                style={{ marginLeft: "10px" }}
                onClick={this.openEditGroup}
              >
                Edit Group
              </button>
              <button
                className="button alert"
                style={{ marginLeft: "10px" }}
                onClick={this.deleteGroup}
              >
                Delete Group
              </button>
              <button
                className="button secondary"
                style={{ marginLeft: "10px" }}
                onClick={() => this.setState({ selectedGroupId: "" })}
              >
                Cancel
              </button>
            </>
          )}
        </div>
        <div
          style={{
            overflowX: "auto",
          }}
        >

          <div
            className="grid-row header hide-for-small-only"
            style={{ position: "sticky" }}
          >
            <div style={{ flex: columnWidths[columnMap.outletNumber] }}>Outlet #</div>
            <div style={{ flex: columnWidths[columnMap.outletName] }}>Outlet Name</div>
            <div style={{ flex: columnWidths[columnMap.customField1] }}>Custom Field 1</div>
            <div style={{ flex: columnWidths[columnMap.customField2] }}>Custom Field 2</div>
            <div style={{ flex: columnWidths[columnMap.pdu] }}>PDU</div>
            <div style={{ flex: columnWidths[columnMap.state] }}>State</div>
            {!noOutletsWithPowerMeasurements && (
              <>
                <div style={{ flex: columnWidths[columnMap.currentRms] }}>Current RMS</div>
                <div style={{ flex: columnWidths[columnMap.power] }}>Power</div>
                <div style={{ flex: columnWidths[columnMap.voltage] }}>Voltage</div>
              </>
            )}
            {outletsSwitchesAllowed && (
              <div style={{ flex: columnWidths[columnMap.operation] }}>Operation</div>
            )}
          </div>

          <div className="show-for-small-only outlet-card__list-header">
            Manage Outlets
          </div>

          {loading && filteredOutlets.length === 0 &&  (
            <LoadingSection
              columnWidths={columnWidths}
              columnMap={columnMap}
              showPowerColumns={!noOutletsWithPowerMeasurements}
            />
          )}

          {!loading && filteredOutlets.length === 0 && (
            <React.Fragment>
              <div className="grid-row-wrapper">
                <div className="grid-row">
                  <div
                    style={{
                      paddingLeft: "50px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div>No Outlets Found</div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "40px",
                }}
              >
                <span className="button">
                  <a
                    href="https://synaccess.readme.io/reference/connect-a-synlink-pdu"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "white" }}
                  >
                    Learn how to connect a SynLink PDU
                  </a>
                </span>
              </div>
            </React.Fragment>
          )}

          {filteredOutlets.map(outlet => (
            <OutletTableRow
              key={outlet.outlet_id}
              noOutletsWithPowerMeasurements={noOutletsWithPowerMeasurements}
              outlet={outlet}
              outletsSwitchesAllowed={outletsSwitchesAllowed}
              columnWidths={columnWidths}
              columnMap={columnMap}
              device={device}
              deviceLoading={loading}
              updateOutlet={updateOutlet}
              editOutletName={this.editOutletName}
              dark={dark}
            />
          ))}

          {canShowOutletLogChart && (
            <div className="grid-x grid-padding-x grid-padding-y">
              <div className="cell">
                <DeviceLogChart
                  title="Outlet Current RMS"
                  subtitle={outletChartSubtitle}
                  logType="outlets"
                  enclosureSerialNumber={serial}
                  resourceId={selectedOutletIdForChart}
                  metricKey="currentRms"
                  metricLabel="Current RMS"
                  unit="A"
                  color="#16a34a"
                  controls={outletSelectionControls}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  
  }
}


class EditOutletForm extends React.Component {
  state = {
    outletName: "",
    customfield1: "",
    customfield2: "",
    loading: false,
  };
  componentDidMount() {
    this.setState({
      outletName: this.props.outlet.outletName,
      customfield1: this.props.outlet.customfield1 || "",
      customfield2: this.props.outlet.customfield2 || "",
    });
  }
  render() {
    const { outlet, close } = this.props;

    return (
      <div>
        <TextInput
          label="Outlet Name"
          value={this.state.outletName}
          callback={(txt) => {
            this.setState({ outletName: txt });
          }}
          placeholder="Enter Outlet Name"
        />
        <TextInput
          label="Custom Field 1"
          value={this.state.customfield1}
          callback={(txt) => {
            this.setState({ customfield1: txt });
          }}
          maxLength={128}
          placeholder="Optional equipment identifier"
          description="Use this field to store equipment IDs or notes for this outlet."
        />
        <TextInput
          label="Custom Field 2"
          value={this.state.customfield2}
          callback={(txt) => {
            this.setState({ customfield2: txt });
          }}
          maxLength={128}
          placeholder="Optional equipment identifier"
        />
        <button
          className="button"
          onClick={() => {
            this.setState({ loading: true });
            this.props.updateOutlet(
              outlet.outlet_id,
              {
                outletName: this.state.outletName,
                customfield1: this.state.customfield1,
                customfield2: this.state.customfield2,
              },
              (err, res) => {
                this.setState({ loading: false });
                if (err) {
                  console.log(err);
                } else {
                  close();
                }
              },
            );
          }}
        >
          {this.state.loading ? <Loading /> : "Change"}
        </button>
      </div>
    );
  }
}


const Chartz = ({
  sections = [
    {
      value: "",
      title: "",
      description: "",
    },
  ],
  loading,
}) => {
  return (
    <div
      className="grid-x grid-padding-x grid-padding-y"
      style={{ marginTop: "0px" }}
    >
      {sections.map((section) => {
        if (section.component) {
          const TempComponent = section.component;
          return <TempComponent />;
          // return {section.component}
        }
        return (
          <div key={section.title} className="cell large-3 medium-6">
            <div
              style={{
                flex: 1,
                borderRadius: "3px",
                display: "flex",
                alignItems: "flex-start",
                paddingLeft: "20px",
                justifyContent: "flex-start",
                // textAlign: "flex-start",
                height: "100%",
                boxShadow: "2px 2px 5px rgba(0,0,0,0.14)",
              }}
              className="app-item"
            >
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "120px",
                  }}
                >
                  <Loading black />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                >
                  <div>{section.title}</div>
                  <div
                    style={{
                      fontSize: "150%",
                      fontWeight: "600",
                      padding: "12px 0px 7px 0px",
                    }}
                  >
                    {section.value}
                  </div>
                  <div
                    style={{
                      color: "grey",
                      fontSize: "85%",
                    }}
                  >
                    {section.description}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};


const Loading = ({ size, black, fixed }) => (
  <div
    id={fixed ? "wrapper-fixed" : "wrapper"}
    style={{ padding: "3px", marginRight: "3px" }}
  >
    <div className="profile-main-loader" style={{ padding: "0px" }}>
      <div
        className="loader"
        style={{
          width: size || "20px",
          height: size || "20px",
          padding: "0px",
        }}
      >
        <svg className="circular-loader" viewBox="25 25 50 50">
          <circle
            className={black ? "loader-path-black" : "loader-path"}
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="2"
          />
        </svg>
      </div>
    </div>
  </div>
);




const LoadingSection = ({ columnWidths, columnMap, showPowerColumns }) => (
  <div>
    {[0, 1, 2, 3].map(index => (
      <div className="grid-row-wrapper" key={index}>
        <div className="grid-row">
          <div style={{ flex: columnWidths[columnMap.outletNumber] }}>
            <div className="skeleton-blank" />
          </div>
          <div style={{ flex: columnWidths[columnMap.outletName] }}>
            <div className="skeleton-blank" />
          </div>
          <div style={{ flex: columnWidths[columnMap.customField1] }}>
            <div className="skeleton-blank" />
          </div>
          <div style={{ flex: columnWidths[columnMap.customField2] }}>
            <div className="skeleton-blank" />
          </div>
          <div style={{ flex: columnWidths[columnMap.pdu] }}>
            <div className="skeleton-blank" />
          </div>
          <div style={{ flex: columnWidths[columnMap.state] }}>
            <div className="skeleton-blank" />
          </div>
          {showPowerColumns && (
            <>
              <div style={{ flex: columnWidths[columnMap.currentRms] }}>
                <div className="skeleton-blank" />
              </div>
              <div style={{ flex: columnWidths[columnMap.power] }}>
                <div className="skeleton-blank" />
              </div>
              <div style={{ flex: columnWidths[columnMap.voltage] }}>
                <div className="skeleton-blank" />
              </div>
            </>
          )}
          <div style={{ flex: columnWidths[columnMap.operation] }}>
            <div className="skeleton-blank" />
          </div>
        </div>
      </div>
    ))}
  </div>
);


class OutletTableRow extends React.Component {
  state = {
    loading: false,
  };

  sendUpdateOutletRequest = (outletId, status) => {
    this.setState({
      loading: true,
    });
    this.props.updateOutlet(outletId, status, (err) => {
      this.setState({
        loading: false,
      });
      if (err) {
        console.error(err);
      }
    });
  };

  renderStateContent = ({ outlet, isDeviceLoading }) => {
    if (isDeviceLoading) {
      return <div className="skeleton-blank slim" />;
    }

    if (outlet.state === undefined) {
      return "-";
    }

    return (
      <span
        style={{
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <span
          style={{
            color:
              outlet.state === "ON"
                ? "forestgreen"
                : outlet.state === "OFF"
                ? "maroon"
                : "",
            fontWeight: "600",
            display: "flex",
          }}
        >
          {(outlet.state || "").toUpperCase()}
        </span>
        <span
          style={{
            color:
              outlet.rebootStatus === "pendingOff"
                ? "maroon"
                : outlet.rebootStatus === "pendingOn"
                ? "forestgreen"
                : "",
          }}
        >
          {outlet.rebootStatus === "pendingOn"
            ? "(Pending On)"
            : outlet.rebootStatus === "pendingOff"
            ? "(Pending Off)"
            : ""}
        </span>
      </span>
    );
  };

  renderCurrentRms = ({ outlet, isDeviceLoading, maxOutletReceptacle }) => {
    if (isDeviceLoading) {
      return <div className="skeleton-blank slim" />;
    }

    if (outlet.currentRms !== undefined && outlet.currentRms !== null) {
      return (
        <span style={{ display: "flex" }}>
          <span
            style={{
              width: "max-content",
              alignItems: "center",
              display: "flex",
              paddingRight: "5px",
              paddingLeft: "5px",
              color:
                outlet.state !== "ON"
                  ? `#875b5b`
                  : `${getColor(outlet.currentRms / maxOutletReceptacle)}`,
            }}
          >
            <DataValue value={(outlet.currentRms || 0).toFixed(2)} unit="A" />
            <span style={{ padding: "0px 3px" }}>/</span>
            <DataValue value={maxOutletReceptacle.toFixed(2)} unit="A Max" />
          </span>
        </span>
      );
    }

    return "-";
  };

  renderPower = ({ outlet, isDeviceLoading }) => {
    if (typeof outlet.power !== "number") {
      return "-";
    }

    if (isDeviceLoading) {
      return <div className="skeleton-blank slim" />;
    }

    return <DataValue value={(outlet.power || 0).toFixed(2)} unit="VA" />;
  };

  renderVoltage = ({ outlet, isDeviceLoading }) => {
    if (typeof outlet.circuitVoltage !== "number") {
      return "-";
    }

    if (isDeviceLoading) {
      return <div className="skeleton-blank slim" />;
    }

    return <DataValue value={(outlet.circuitVoltage || 0).toFixed(2)} unit="V" />;
  };

  renderCustomField = value => {
    if (!value) {
      return <span style={{ color: "#9ca3af" }}>Not set</span>;
    }
    return <span title={value}>{value}</span>;
  };

  getOperationConfigs = ({ outlet, darkMode }) => {
    const configs = [];

    if (outlet.state === "OFF") {
      configs.push({
        key: "turn-on",
        label: "Turn On",
        mobileLabel: "Turn On",
        icon: "offline_bolt",
        iconColor: "forestgreen",
        backgroundColor: darkMode ? "#2e4a2e" : "rgb(194 223 194)",
        textColor: darkMode ? "#f3f3f3" : undefined,
        style: { padding: "3px 5px" },
        action: () => this.sendUpdateOutletRequest(outlet.outlet_id, { state: "ON" }),
        title: "Switch Outlet from OFF state to ON state",
      });
    }

    if (outlet.state === "ON") {
      configs.push({
        key: "turn-off",
        label: "Turn Off",
        mobileLabel: "Turn Off",
        icon: "pause_circle",
        iconColor: "maroon",
        backgroundColor: darkMode ? "#4a2e2e" : "rgb(235 210 210)",
        textColor: darkMode ? "#f3f3f3" : undefined,
        style: { padding: "3px 5px" },
        action: () => this.sendUpdateOutletRequest(outlet.outlet_id, { state: "OFF" }),
        title: "Switch Outlet from ON state to OFF state",
      });
    }

    if (outlet.state) {
      configs.push({
        key: "cycle",
        label: "Cycle",
        mobileLabel: "Cycle",
        icon: "replay",
        iconColor: "#1f2933",
        backgroundColor: darkMode ? "#e2e8f0" : "#d9e2ec",
        textColor: "#1f2933",
        style: {
          paddingLeft: "5px",
          paddingTop: "3px",
          paddingBottom: "3px",
          paddingRight: "0px",
        },
        action: () => this.sendUpdateOutletRequest(outlet.outlet_id, { state: "REBOOT" }),
        title: "Reboot Outlet with outlet configured reboot time",
      });
    }

    return configs;
  };

  renderDeviceContent = ({ deviceSerial, deviceName, isDeviceLoading }) => {
    if (isDeviceLoading) {
      return <div className="skeleton-blank slim" />;
    }

    return (
      <Link to={`/devices/connected/${deviceSerial}`}>
        {deviceName}
      </Link>
    );
  };

  render() {
    const {
      outlet,
      columnWidths,
      columnMap,
      outletsSwitchesAllowed,
      noOutletsWithPowerMeasurements,
      device,
      deviceLoading,
      dark,
      editOutletName,
    } = this.props;

    const darkMode =
      typeof dark === "boolean"
        ? dark
        : document.body.classList.contains("dark-mode");

    const { loading } = this.state;

    const maxOutletReceptacle =
      {
        "IEC 60309 C13R": 12,
        "IEC 60309 C19R": 16,
        "NEMA 5-20R": 16,
      }[outlet.receptacle] || 16;

    const connectionEstablished = outlet.connectionState === "Connected";
    const deviceSerial = device?.enclosureSerialNumber || outlet.enclosureSerialNumber;
    const deviceDisplayName =
      device && (device.deviceName === "SynLink PDU" || !device.deviceName)
        ? `PDU SN:${deviceSerial}`
        : device?.deviceName || `PDU SN:${deviceSerial}`;

    const outletDetailLink = `/devices/connected/${deviceSerial}/outlets/${outlet.outlet_id}`;
    const isDeviceLoading = Boolean(deviceLoading || device?.loading);

    const stateContent = this.renderStateContent({
      outlet,
      isDeviceLoading,
    });
    const currentRmsContent = this.renderCurrentRms({
      outlet,
      isDeviceLoading,
      maxOutletReceptacle,
    });
    const powerContent = this.renderPower({ outlet, isDeviceLoading });
    const voltageContent = this.renderVoltage({ outlet, isDeviceLoading });
    const deviceContent = this.renderDeviceContent({
      deviceSerial,
      deviceName: deviceDisplayName,
      isDeviceLoading,
    });

    const operationConfigs = outletsSwitchesAllowed
      ? this.getOperationConfigs({ outlet, darkMode })
      : [];

    const metadataFields = [
      {
        key: "pdu",
        label: "PDU",
        value: deviceContent,
      },
      {
        key: "customfield1",
        label: "Custom Field 1",
        value: this.renderCustomField(outlet.customfield1),
        skipDefaultValueClass: true,
      },
      {
        key: "customfield2",
        label: "Custom Field 2",
        value: this.renderCustomField(outlet.customfield2),
        skipDefaultValueClass: true,
      },
      {
        key: "state",
        label: "State",
        value: stateContent,
        valueClassName: "outlet-card__value--status",
      },
    ];

    const metricFields = noOutletsWithPowerMeasurements
      ? []
      : [
          {
            key: "current",
            label: "Current RMS",
            value: currentRmsContent,
          },
          {
            key: "power",
            label: "Power",
            value: powerContent,
          },
          {
            key: "voltage",
            label: "Voltage",
            value: voltageContent,
          },
        ];

    const operationsContent =
      outletsSwitchesAllowed && operationConfigs.length > 0 ? (
        <div className="outlet-card__operations">
          {operationConfigs.map((config) => (
            <button
              key={`${outlet.outlet_id}-${config.key}-mobile`}
              type="button"
              className="outlet-card__operation-button"
              style={{
                backgroundColor: config.backgroundColor,
                color: config.textColor || "inherit",
                cursor: loading ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (!loading) {
                  config.action();
                }
              }}
              title={config.title}
              disabled={loading}
              aria-busy={loading}
            >
              {loading ? (
                <React.Fragment>
                  <Loading black />
                  <span>Loading...</span>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <i
                    className="material-icons"
                    aria-hidden="true"
                    style={{ color: config.iconColor }}
                  >
                    {config.icon}
                  </i>
                  <span>{config.mobileLabel || config.label}</span>
                </React.Fragment>
              )}
            </button>
          ))}
        </div>
      ) : null;
    const footerContent = operationsContent || null;

    return (
      <>
        <div
          key={`${outlet.outlet_id}-table`}
          className={`grid-row-wrapper hide-for-small-only ${
            connectionEstablished ? "" : "disconnected"
          }`}
          title={connectionEstablished ? "" : "Disconnected"}
        >
          <div
            className={`grid-row ${
              connectionEstablished ? "connected" : "disconnected"
            }`}
            style={{ marginBottom: "4px" }}
          >
            <div style={{ flex: columnWidths[columnMap.outletNumber] }}>
              <Link to={outletDetailLink}>{outlet.pduLabeledOutletNum}</Link>
            </div>
            <div style={{ flex: columnWidths[columnMap.outletName] }}>
              <Link to={outletDetailLink}>
                <span style={{ textDecoration: "underline" }}>
                  {outlet.outletName}
                </span>
              </Link>
              <span
                className="hover-show"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "8px",
                }}
                onClick={() => editOutletName(outlet)}
              >
                <span className="hover-item">
                  <i className="material-icons">edit</i>
                </span>
              </span>
            </div>
            <div style={{ flex: columnWidths[columnMap.customField1] }}>
              {this.renderCustomField(outlet.customfield1)}
            </div>
            <div style={{ flex: columnWidths[columnMap.customField2] }}>
              {this.renderCustomField(outlet.customfield2)}
            </div>
            <div style={{ flex: columnWidths[columnMap.pdu] }}>{deviceContent}</div>
            <div style={{ flex: columnWidths[columnMap.state] }}>{stateContent}</div>
            {!noOutletsWithPowerMeasurements && (
              <>
                <div
                  style={{ flex: columnWidths[columnMap.currentRms] }}
                  title={`${outlet.receptacle} Receptacle`}
                >
                  {currentRmsContent}
                </div>
                <div style={{ flex: columnWidths[columnMap.power] }}>{powerContent}</div>
                <div style={{ flex: columnWidths[columnMap.voltage] }}>{voltageContent}</div>
              </>
            )}
            {outletsSwitchesAllowed && (
              <div
                style={{
                  flex: columnWidths[columnMap.operation],
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "6px",
                }}
              >
                {operationConfigs.map((config) => (
                  <div
                    key={`${outlet.outlet_id}-${config.key}-desktop`}
                    className="spreadsheet-badge"
                    style={{
                      marginRight: "3px",
                      cursor: loading ? "not-allowed" : "pointer",
                      ...config.style,
                      backgroundColor: config.backgroundColor,
                      color: config.textColor,
                    }}
                    onClick={() => {
                      if (!loading) {
                        config.action();
                      }
                    }}
                    title={config.title}
                  >
                    {loading ? (
                      <React.Fragment>
                        <Loading black />
                        <b>Loading</b>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <i
                          className="material-icons"
                          style={{
                            marginRight: "0px",
                            color: config.iconColor,
                          }}
                        >
                          {config.icon}
                        </i>
                        <b
                          className="show-for-largexx"
                          style={{ minWidth: "50px" }}
                        >
                          {config.label}
                        </b>
                      </React.Fragment>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <OutletCard
          key={`${outlet.outlet_id}-card`}
          detailLink={outletDetailLink}
          outletNumber={outlet.pduLabeledOutletNum}
          outletName={outlet.outletName}
          connectionEstablished={connectionEstablished}
          onRename={() => editOutletName(outlet)}
          metadata={metadataFields}
          metrics={metricFields}
          footerContent={footerContent}
        />
      </>
    );
  }
}

const normalizeOutletId = (value) => {
  if (value === undefined || value === null) return value;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? value : parsed;
};

const formatOutletLabel = (outlet, fallbackId) => {
  if (!outlet) {
    return `Outlet ${fallbackId}`;
  }
  const outletNumber =
    outlet.pduLabeledOutletNum ?? outlet.outlet_id ?? fallbackId;
  const baseLabel =
    outletNumber !== undefined && outletNumber !== null && outletNumber !== ""
      ? `Outlet ${outletNumber}`
      : `Outlet ${fallbackId}`;
  const trimmedName = (outlet.outletName || "").trim();
  if (
    trimmedName &&
    trimmedName !== baseLabel &&
    trimmedName !== `Outlet ${outlet.pduLabeledOutletNum}`
  ) {
    return `${baseLabel} - ${trimmedName}`;
  }
  return baseLabel;
};

class OutletGroupForm extends React.Component {
  constructor(props) {
    super(props);
    const g = props.group || {};
    const initialSelected = g.outlets
      ? g.outlets.map((o) => normalizeOutletId(o.id))
      : [];
    this.state = {
      name: g.groupName || "",
      delay: g.groupRebootSequenceDelay || 0,
      selected: initialSelected,
      loading: false,
      addSelection: "",
    };
  }

  handleAddOutlet = (value) => {
    if (!value) {
      this.setState({ addSelection: "" });
      return;
    }
    const normalizedId = normalizeOutletId(value);
    this.setState((prev) => {
      const alreadySelected = prev.selected.some(
        (id) => String(id) === String(normalizedId)
      );
      if (alreadySelected) {
        return { addSelection: "" };
      }
      return {
        selected: [...prev.selected, normalizedId],
        addSelection: "",
      };
    });
  };

  removeOutlet = (idToRemove) => {
    this.setState((prev) => ({
      selected: prev.selected.filter(
        (id) => String(id) !== String(idToRemove)
      ),
    }));
  };

  submit = () => {
    const { name, delay, selected } = this.state;
    this.setState({ loading: true });
    this.props.onSubmit(
      {
        groupName: name,
        groupRebootSequenceDelay: delay,
        outlets: selected,
      },
      () => this.setState({ loading: false })
    );
  };

  render() {
    const { outlets, close } = this.props;
    const { name, delay, selected, loading, addSelection } = this.state;

    const selectedIdSet = new Set(selected.map((id) => String(id)));
    const availableOutlets = outlets.filter(
      (o) => !selectedIdSet.has(String(o.outlet_id))
    );

    const orderedSelectedOutlets = selected.map((id) => {
      const normalizedId = normalizeOutletId(id);
      const outlet = outlets.find(
        (o) => String(o.outlet_id) === String(normalizedId)
      );
      return { id: normalizedId, outlet };
    });

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div>
          <TextInput
            label="Group Name"
            value={name}
            callback={(value) => this.setState({ name: value })}
          />
        </div>
        <div>
          <TextInput
            label="Reboot Sequence Delay"
            type="number"
            value={delay}
            callback={(value) => this.setState({ delay: value })}
          />
        </div>
        <div>
          <div
            style={{
              fontSize: "0.95rem",
              marginBottom: "6px",
            }}
          >
            Add an Outlet
          </div>
          <select
            value={addSelection}
            onChange={(e) => this.handleAddOutlet(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem 0.65rem",
              borderRadius: "6px",
              border: "1px solid #cbd5e1",
              fontSize: "0.95rem",
            }}
            disabled={availableOutlets.length === 0}
          >
            <option value="">
              {availableOutlets.length === 0
                ? "All available outlets are already added"
                : "Add an outlet..."}
            </option>
            {availableOutlets.map((o) => (
              <option key={o.outlet_id} value={o.outlet_id}>
                {formatOutletLabel(o, o.outlet_id)}
              </option>
            ))}
          </select>
          <div
            style={{
              marginTop: "6px",
              fontSize: "0.85rem",
              color: "#6b7280",
            }}
          >
            {availableOutlets.length > 0
              ? "Select outlets in the desired order. Newly added outlets appear at the bottom of the list."
              : "All available outlets are already added to this group."}
          </div>
        </div>
        <div>
          <div
            style={{
              fontSize: "0.95rem",
              marginBottom: "6px",
            }}
          >
            Selected Outlets
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              maxHeight: "320px",
              overflowY: "auto",
              paddingRight: "4px",
            }}
          >
            {orderedSelectedOutlets.length === 0 ? (
              <div
                style={{
                  padding: "0.75rem",
                  borderRadius: "6px",
                  border: "1px dashed #cbd5e1",
                  color: "#64748b",
                  fontSize: "0.9rem",
                }}
              >
                No outlets selected yet.
              </div>
            ) : (
              orderedSelectedOutlets.map((entry, index) => (
                <div
                  key={`${entry.id}-${index}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    border: "1px solid #dbe3eb",
                    borderRadius: "6px",
                    padding: "0.3rem 0.5rem",
                    backgroundColor: "#f9fafb",
                    gap: "12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      minWidth: 0,
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        color: "#334155",
                      }}
                    >
                      {index + 1}.
                    </span>
                    <span
                      style={{
                        color: "#1f2937",
                        fontSize: "0.95rem",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {formatOutletLabel(entry.outlet, entry.id)}
                    </span>
                  </div>
                  <button
                    type="button"
                    className="button secondary"
                    style={{
                      marginLeft: "auto",
                      marginBottom: "0px",
                      padding: "0.35rem 0.75rem",
                      fontSize: "0.85rem",
                      lineHeight: 1.2,
                    }}
                    onClick={() => this.removeOutlet(entry.id)}
                  >
                    Remove
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "10px",
            paddingTop: "8px",
          }}
        >
          <button
            type="button"
            className="button"
            onClick={this.submit}
            disabled={loading}
          >
            {loading ? <Loading /> : "Save"}
          </button>
          <button
            type="button"
            className="button secondary"
            onClick={() => close()}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }
}

const DataValue = ({ value, unit }) => {
  return (
    <span style={{ display: "flex", alignItems: "flex-end" }}>
      <span
        style={{
          fontWeight: "600",
          fontSize: "105%",
        }}
      >
        {value}
      </span>
      <span
        style={{
          fontSize: "80%",
          paddingLeft: "4px",
          paddingBottom: "1px",
        }}
      >
        {unit}
      </span>
    </span>
  );
};
function getColor(value, opacity = 1) {
  //value from 0 to 1
  return value > 1
    ? "#9d0002" //red
    : value > 0.75
    ? "#b87000" //orange
    : value > 0.5
    ? "#CC9900" //yellow
    : value > 0.25
    ? "#7c9d00" // yellow green
    : "green";
}
